
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/subscriptions",
      function () {
        return require("private-next-pages/dashboard/subscriptions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/subscriptions"])
      });
    }
  